/*
 * @Author: yanghailong
 * @Date: 2023-01-12 16:43:57
 * @Last Modified by: yanghailong
 * @Last Modified time: 2024-07-25 20:41:34
 */
import { createRouter, createWebHistory } from "vue-router"
import { getToken } from "../module/storage"
import routes from './routes'

const router = createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHistory(),
  routes, // `routes: routes` 的缩写
})

router.beforeEach((to, from, next) => {
  if (getToken()) {
    next()
  } else {
    if (to.path != '/login') {
      next({ path: '/login' })
    } else {
      next()
    }
  }
})


export default router
